import React, { useEffect, useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Input, Modal } from "antd";
import { createOrganizations } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface CreateOrganizationsModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function CreateOrganizationsModal(props: CreateOrganizationsModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [checked, setChecked] = React.useState(false);
  const loading = useSelector((state: RootState) => state.OrganizationsPageState.createOrganizationLoading);
  const [error, setError] = React.useState<string>("");
  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
    setChecked(false);
  };

  useEffect(() => {
    return () => {
      setError("");
      form.resetFields();
      setChecked(false);
    };
  }, [props.openState]);

  const CreateOrganizationsModalContent = () => {
    const onFinish = async (value: any) => {
      const requestBody = {
        Name: value.name,
        DefaultTenant: value.assignUsers ? value.assignUsers : false,
      };
      try {
        await dispatch(createOrganizations(requestBody)).unwrap();
        handleModalClose();
      } catch (error: any) {
        setError(error.response.data.detailedMessages[0] ? error.response.data.detailedMessages[0] : "An error occurred while creating the organization. Please try again.");
      }
    };

    return (
      <div style={{ width: "100%" }}>
        <h4> Create Organization</h4>

        <Form
          form={form}
          colon={false}
          name="createOrganizationForm"
          layout="horizontal"
          onFinish={onFinish}>
          <Form.Item
            className="form-item"
            label="Name :"
            name="name"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide Name.",
              },
            ]}
            style={{ marginTop: "25px" }}>
            <Input />
          </Form.Item>

          {/* <Form.Item
            name="assignUsers"
            valuePropName="checked"
            style={{ width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Assign new users to this tenant by default:</span>
              <Checkbox
                onChange={(e) => setChecked(e.target.checked)}
                checked={checked}
                style={{
                  transform: "scale(0.6)",
                  position: "relative",
                  top: "-1px",
                  marginLeft: "8px",
                }}
              />
            </div>
          </Form.Item> */}
        </Form>
        {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}
        <div className="d-flex gap-3 justify-content-end">
          <Button
            htmlType="reset"
            onClick={handleModalClose}
            loading={loading}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
            loading={loading}>
            Create
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={500}
        onCancel={handleModalClose}
        open={props.openState}>
        <CreateOrganizationsModalContent />
      </Modal>
    </div>
  );
}

export default CreateOrganizationsModal;
